/*
 * Copyright (c) 2024. Devtron Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const Pod = ({ color = 'var(--B500)', style = {}, onClick = null }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '24px', height: '24px', ...style }} viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    fill={color}
                    fillRule="nonzero"
                    d="M4 20v2H2v-2h2zm4 0v2H6v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2zm2-19a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h15zM4 16v2H2v-2h2zM21 3H8v13h13V3zM4 12v2H2v-2h2zm0-4v2H2V8h2zm0-4v2H2V4h2z"
                />
            </g>
        </svg>
    )
}

export const Trash = ({ color = 'var(--R500)', style = {}, onClick = null, ...rest }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.5 5.00001H4.16667M4.16667 5.00001H17.5M4.16667 5.00001L4.16667 16.6667C4.16667 17.5872 4.91286 18.3333 5.83333 18.3333H14.1667C15.0871 18.3333 15.8333 17.5872 15.8333 16.6667V5.00001M6.66667 5.00001V3.33334C6.66667 2.41286 7.41286 1.66667 8.33334 1.66667H11.6667C12.5871 1.66667 13.3333 2.41286 13.3333 3.33334V5.00001M8.33333 9.16667V14.1667M11.6667 9.16667V14.1667"
                stroke="#596168"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const Pencil = ({ color = 'var(--N700)', style = {}, ...props }) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '24px', height: '24px', ...style }}
            viewBox="0 0 24 24"
            data-testid="group-name-edit-icon"
        >
            <g fill="none" fillRule="evenodd">
                <path
                    fill={color}
                    fillRule="nonzero"
                    d="M4.5 16.375V19.5h3.125l9.217-9.217-3.125-3.125L4.5 16.375zm14.758-8.508a.83.83 0 0 0 0-1.175l-1.95-1.95a.83.83 0 0 0-1.175 0l-1.525 1.525 3.125 3.125 1.525-1.525z"
                />
            </g>
        </svg>
    )
}

export const DropdownIcon = ({ style = {}, color = 'var(--B500)', ...props }) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '24px', height: '24px', ...style }}
            viewBox="0 0 24 24"
        >
            <g fill="transparent" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    stroke={`${color}`}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 11l4 4 4-4"
                />
            </g>
        </svg>
    )
}

export const Info = ({ color = 'var(--B500)', style = {}, ...rest }) => {
    return (
        <svg
            {...rest}
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '24px', height: '24px', ...style }}
            viewBox="0 0 32 32"
        >
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h32v32H0z" />
                <path
                    fill={color}
                    d="M16 2.667C8.64 2.667 2.667 8.64 2.667 16S8.64 29.333 16 29.333 29.333 23.36 29.333 16 23.36 2.667 16 2.667z"
                />
                <path
                    fill="#FFF"
                    d="M16 14.667c.736 0 1.333.597 1.333 1.333v5.333a1.333 1.333 0 1 1-2.666 0V16c0-.736.597-1.333 1.333-1.333zm0-5.334A1.333 1.333 0 1 1 16 12a1.333 1.333 0 0 1 0-2.667z"
                />
            </g>
        </svg>
    )
}
